<div class="fullwidth locateForm">
  <app-responsive-list-view
       [tableColumns]="tableColumns"
       [sortingDataAccessor]="sortingDataAccessor"
       [filteringPredicate]="filteringPredicate"
       [service]="classificationService"
       [withAdd]="canAdd"
       [hasListAccess]="hasListAccess"
       [maxCellStringLength]="80"
       [maxStringLength]="20"
       [inputFilterEventSubject]="filterEventSubject.asObservable()"
       (mode)="updateViewMode($event)"
       [_tableMenuAction]="tableMenuAction"
       (menuActionEventEmitter)="tableMenuActionHandler($event)"
       addButtonLabel="{{ 'classification.fields.create-level' | translate}}"
       tableTitleLabel="{{ 'classification.title' | translate}}"
       [inputReloadEventSubject]="reloadEventSubject.asObservable()"
       [showFilterButton]="true"
       [showBackButton]="false"
       [initiateSearchFromFilter]="true"
       initialPageSize="10">
    <app-table-filter filter-content [filters]="filters" (filterOutput)="applyFilter($event)" [showFilterButton]="false" [predefinedFilter]="predefinedFilter" [initiateSearchFromFilter]="true"></app-table-filter>
    <app-table-filter filter-content-mobile [filters]="filters" (filterOutput)="applyFilter($event)" [showFilterButton]="false" [predefinedFilter]="predefinedFilter" [initiateSearchFromFilter]="true"></app-table-filter>
  </app-responsive-list-view>
</div>
